<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 mt-10">
        <product style="width: 100%;" v-for="favourite in favourites" :key="favourite.id" :model="favourite"></product>
        <h4 v-if="!State.idArray.length" class="text-gold">No favourites added</h4>
    </div>
</template>

<script>
import Product from '../filters/Product.vue'
import { reactive, watch } from 'vue'
import State from './State'
const axios = require('axios')
export default {
    components: { Product },
    setup() {
        const favourites = reactive([])

        watch(State.idArray, getModelsById, { immediate: true })

        function getModelsById() {
            if (!State.idArray.length) return favourites.length = 0
            axios.post('/api/models', {
                [window.csrfTokenName]: window.csrfTokenValue,
                idArray: State.idArray
            }).then(({ data }) => {
                favourites.length = 0
                favourites.push(...data)
            })
        }

        return { favourites, State }
    },
}
</script>